import { gql } from '@apollo/client';

export const USERS = gql`
  query User {
    users {
      id
      isVerified
      name
      email
      role
    }
  }
`;

export const USER = gql`
  query User($id: ID!) {
    user(id: $id) {
      id
      isVerified
      name
      email
      role
      createdAt
    }
  }
`;
